export default __webpack_public_path__ + "static/media/logo_TDSA.12272fe4.svg";